import { z } from "zod";

export const ICON_TYPES = [
  "arrow-left",
  "arrow-right",
  "attach-file",
  "arrow-up-right-from-square",
  "badge-check",
  "bell-solid",
  "binoculars",
  "book",
  "bookmark",
  "briefcase",
  "briefcase-outlined",
  "building",
  "building-thick",
  "calendar",
  "calendar-day",
  "caret-bottom",
  "caret-double-left",
  "caret-double-right",
  "centered-circle",
  "chart-line-increase",
  "check",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clock",
  "clock-back",
  "clock-outlined",
  "clock-simple",
  "close",
  "collapse-vertical",
  "cogwheel",
  "coordinates-person",
  "clipboard-bunny-gold",
  "dash",
  "documents",
  "dollar",
  "door-straight",
  "download",
  "ellipsis",
  "ellipsis-vertical",
  "expand-vertical",
  "files",
  "filter",
  "folder-person",
  "folder-view",
  "general-stop",
  "gauge",
  "gps-disabled",
  "group",
  "headset",
  "house-building",
  "hybrid-view",
  "hyperlink",
  "identity-card",
  "information",
  "information-circle",
  "key-outline",
  "location-alt",
  "magnifying-glass",
  "map-pin",
  "map-pin-filled",
  "medal-star-alt",
  "message",
  "microscope",
  "minus",
  "money-dollar",
  "mug",
  "notepad-alt",
  "notepad-problem",
  "padlock-locked",
  "padlock-locked-outlined",
  "palm-dollar",
  "pencil",
  "people",
  "person-male",
  "person-male-formal",
  "person-superstar",
  "plus",
  "printer",
  "profile",
  "question-circle",
  "reload",
  "replay",
  "ribbon",
  "route",
  "send",
  "share",
  "sorted-ascending-arrows",
  "sorted-descending-arrows",
  "stack-vertical",
  "star-five-sides",
  "student",
  "trash",
  "triangle-down",
  "triangles-dots-horizontal-collapse",
  "triangles-dots-horizontal-expand",
  "unsorted-arrows",
  "variant",
  "warning",
  "zoom-in",
  "zoom-out",
] as const;

export type IconType = (typeof ICON_TYPES)[number];

export const iconTypeSchema = z.enum(ICON_TYPES);
